import React, {useCallback, useEffect, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import { Col, Row } from 'reactstrap';
import {OrbitProgress} from "react-loading-indicators";

const dropzoneCustom = {
    width: '100%',
    minHeight: 110,
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    fontSize: 16,
    textAlign: 'center',
  };

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
  };
  
  const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 150,
    height: 150,
    padding: 4,
    boxSizing: 'border-box'
  };
  
  const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
  };
  
  const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
  };

  import { useDispatch, useSelector } from "react-redux";
  import { uploadImageProperty as onUploadImage, setUploadImageSuccess,
    deleteImagePropertyInCloud as onDeleteImagePropertyInCloud
   } from "store/Property/actions";
  import imageCompression from "browser-image-compression";

function FormUploadImages (props) {

  const dispatch = useDispatch()

  const { property } = useSelector(state => ({
        property: state.PropertyReducer.property
    }));

    const [filesUploaded, setFilesUploaded] = useState(property?.photos || []);
    const [files, setFiles] = useState([]);
    const [isCompressing, setIsCompressing] = useState(false);
    const { uploadImagesFlagSuccess } = useSelector(state => ({
        uploadImagesFlagSuccess: state.PropertyReducer.uploadImagesFlagSuccess
    }));

    const handleImageUpload  = async (acceptedFiles) => {
        dispatch(setUploadImageSuccess(false))
        setIsCompressing(true); // Activar loader
        const filesNews = acceptedFiles.map(file => Object.assign(file, {
          preview: URL.createObjectURL(file)
       }));
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        }
        try {
            const compressedFiles = [];
            for (const imageFile of filesNews) {
                const compressedFile = await imageCompression(imageFile, options);
                compressedFile.preview = URL.createObjectURL(compressedFile)
                compressedFiles.push(compressedFile);
            }
            const FilesAddEx = [...files]
            FilesAddEx.push(...compressedFiles)
            setFiles(FilesAddEx)
        } catch (error) {
          console.error(error);
            toastr.error("Hubo un error al subir la imagen, intenta nuevamente", "Plataforma Guelaguetza")
        }
        finally {
            setIsCompressing(false); // Desactivar loader
        }
    }

  const {getRootProps, getInputProps} = useDropzone({
    accept: {
      'image/*': []
    },
    onDrop: acceptedFiles => {
      handleImageUpload(acceptedFiles)
    }
  });

  const removeFile = (file) => {
    setFiles(files.filter(f => f.name !== file.name))
  }

  const removeFileInCloud  = (file) => {
    dispatch(onDeleteImagePropertyInCloud(file))  
  }

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner} className='position-relative'>
        <div className="position-absolute top-0 end-0">
          <i className='mdi mdi-trash-can fw-medium display-6 text-danger cursor-pointer' onClick={() => removeFile(file)}></i>
        </div>

        <img
          src={file.preview}
          style={img}
          // Revoke data uri after image is loaded
          onLoad={() => { URL.revokeObjectURL(file.preview) }}
        />
      </div>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    props.handleImagesWithOutOpload(files.length)
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);

  const uploadFile = async () => {
    const formData = new FormData()
    formData.append("propertyId", property?.id)
    files.map(element => {
      formData.append("image[]", element)
    });

    try {
      dispatch(onUploadImage (formData))

    } catch (err) {
      toastr.error("Hubo un error al subir la imagen(es), intenta nuevamente", "Plataforma Guelaguetza")
    }
  };

  useEffect(()=>{
    console.info("uploadImagesFlagSuccess" , uploadImagesFlagSuccess)
    if(uploadImagesFlagSuccess) {
      setFiles([])
      
    }
  },[uploadImagesFlagSuccess]);

  useEffect(()=>{
    setFilesUploaded(property?.photos)
  },[property]);

  return (
    <section className="container">
      <row>
        <Col lg="12">
          <div className="text-end mb-3">
            <button disabled={files.length===0} className="btn btn-danger" type="button"
                    onClick={uploadFile}> Subir imagen(es)
            </button>
          </div>
        </Col>
      </row>
      <div {...getRootProps({style: dropzoneCustom})}>
        <input {...getInputProps()} />
        {isCompressing ? (
            <><p>Comprimiendo imágenes, por favor espera...</p>
             <OrbitProgress color={["#1b36ba", "#2947df", "#556de6", "#8193ed"]} /></>
        ) : (
            <p>Arrastre y suelte algunos archivos aquí o haga clic para seleccionarlos</p>
        )}  
      </div>
      <aside style={thumbsContainer}>
        {thumbs}
      </aside>
      <Row style={thumbsContainer}>
                    <Col  md={12}>
                    {
                        filesUploaded?.map((photo, index) => (
                          <div style={thumb}  className='position-relative' key={index}>
                              <div className="position-absolute top-0 end-0">
                                <i className='mdi mdi-trash-can fw-medium display-6 text-danger cursor-pointer' 
                                onClick={() => removeFileInCloud(photo)}></i>
                              </div>

                              <img src={photo.url_public} alt="Foto del Bien" style={{width:'100%'}}/>
                          </div>
                        ))
                    }
                    </Col>
                </Row>
    </section>
  )
}
export default FormUploadImages
